import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class V2AuthService {
  private environmentUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  requestLoginLink(email): Observable<any> {
    const url = `${this.environmentUrl}/api/v2/auth/login`;
    return this.http.post(url, email);
  }

  redeemLoginToken(token: string): Observable<any> {
    const url = `${this.environmentUrl}/api/v2/auth/token?token=${encodeURIComponent(token)}`;
    return this.http.get(url).pipe(
      catchError(error => {
        return of(null);
      })
    );
  }

  saveToken(token: string): void {
    localStorage.setItem('auth_token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }

  validateToken(token: string): Observable<boolean> {
    const url = `${this.environmentUrl}/api/v2/auth/validate-token?token=${encodeURIComponent(token)}`;
    return this.http.get<{ valid: boolean }>(url).pipe(
      map(response => response.valid),
      catchError(error => {
        return of(false);
      })
    );
  }

  isLoggedIn(): Observable<boolean> {
    const token = this.getToken();
    if (!token) {
      return of(false);
    }

    return this.validateToken(token).pipe(
      map(isValid => {
            if (!isValid) {
                this.logout();
                return false;
            }
            return true;
        }),
        catchError(error => {
            this.logout(); 
            return of(false);
        })
    );
  }

  logout(): void {
    localStorage.removeItem('auth_token');
    this.router.navigate(['/login']);
  }
}
